import React from "react";
import { Row, Col, Breadcrumb, Figure, Form } from "react-bootstrap";
import { t } from "i18next";
// import { LazyLoadImage } from "react-lazy-load-image-component";
const InnerBanner = (props) => {
  return (
    <section className="inner-banner">
      {props.imgsrc ? (
        <Figure className="banner-img">
          {/* <LazyLoadImage */}
          <Figure.Image alt={props?.imgalt} src={props.imgsrc} />
        </Figure>
      ) : (
        ""
      )}
      <div className={`banner-inside ${props.bannerclass ? "mode-white" : props.construction ? "construction-banner" : ""}`}>
        <div className="container">
          <Row>
            <Col md={6} lg={7}>
              <Breadcrumb>
                <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
                <Breadcrumb.Item active>{props.title}</Breadcrumb.Item>
              </Breadcrumb>
              <div className="banner-content">
                <h1 className="title">{props.heading}</h1>
                {props.subcontent ? (
                  <h2 className="subtitle">{props.subcontent}</h2>
                ) : (
                  ""
                )}
                {props.content ? <p>{props.content}</p> : ""}
                {props.quote && props?.button_name === "Pay Now" ? (
                  <a
                    href="#quote"
                    className="btn btn-primary page-scroll"
                    style={{ marginLeft: "57px" }}
                  >
                    {props.button_name ? t(props.button_name) : t("Apply now")}
                  </a>
                ) : props.quote ? (
                  <a href="#quote" className="btn btn-primary page-scroll">
                    {props.button_name ? t(props.button_name) : t("Apply now")}
                  </a>
                ) : (
                  ""
                )}
                {props.locaAgaint ? (
                  <a
                    href="/loan-against-property-eligibility"
                    className="btn btn-primary ml-3"
                  >
                    {props.button_name
                      ? t(props.button_name)
                      : t("Loan Against Property Eligibility")}
                  </a>
                ) : (
                  ""
                )}
                {props.housAgaint ? (
                  <>
                    <a
                      href={
                        localStorage.getItem("language_id") == 0
                          ? "/home-loan-interest-rate"
                          : "/hi/home-loan-interest-rate"
                      }
                      className="btn btn-primary ml-3"
                    >
                      {props.button_name
                        ? t(props.button_name)
                        : t("Housing Loan Interest Rate")}
                    </a>
                    <a
                      href="/calculators/home-loan-eligibility-calculator"
                      className="btn btn-primary ml-3"
                    >
                      {props.button_name
                        ? t(props.button_name)
                        : t("Home Loan Eligiblity Calculator")}
                    </a>
                  </>
                ) : (
                  ""
                )}
                {props.faq ? (
                  <div className="faq-search">
                    <Form>
                      <Form.Group controlId="formPlaintextEmail">
                        <Form.Label>
                          <img src="../img/ico-search.png" alt="" />
                        </Form.Label>
                        <Form.Control
                          type="text"
                          // onKeyPress={(e) => {
                          onChange={(e) => {
                            // if (e.key === "Enter") {
                            e.preventDefault();
                            props.onChange(e);
                            // }
                          }}
                          placeholder={t("Type your question here")}
                        />
                      </Form.Group>
                    </Form>
                  </div>
                ) : (
                  ""
                )}
                {props.blog ? (
                  <div className="faq-search">
                    <Form>
                      <Form.Group controlId="formPlaintextEmail">
                        <Form.Label>
                          <img src="../img/ico-search.png" alt="" />
                        </Form.Label>
                        <Form.Control
                          type="text"
                          // onKeyPress={(e) => {
                          onChange={(e) => {
                            // if (e.key === "Enter") {
                            e.preventDefault();
                            props.onChange(e);
                            // }
                          }}
                          placeholder="Search"
                        />
                      </Form.Group>
                    </Form>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};
export default InnerBanner;
